import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "../../helpers";
import { API_METHOD } from "@constants/constants";

export const customDelete = createAsyncThunk(
  "custom/delete",
  async ({id, url}) => {
    const response = await Client(API_METHOD.DELETE, `${url}/${id}`);
    return response.data;
  }
);
